export enum RecipeType {
  DesignApp = 'DesignApp',
  File = 'File',
}
